var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.463 17H14.54M16.916 4.568a3.064 3.064 0 00-5.034-1.55 3.065 3.065 0 00-5.76 0 3.065 3.065 0 00-5.081 2.78 3.09 3.09 0 002.422 2.524v4.37a1.231 1.231 0 001.23 1.23h8.617a1.23 1.23 0 001.23-1.23v-4.37a3.09 3.09 0 002.376-3.754zM3.463 10.846H14.54",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgKds;